import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // Import useNavigate instead of useHistory
import axios from "axios";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";

const ResetPasswordForm = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const location = useLocation();
  const navigate = useNavigate(); // useNavigate hook to programmatically navigate

  // Extract token from URL
  const token = new URLSearchParams(location.search).get("token");

  useEffect(() => {
    if (!token) {
      setError("Invalid or missing reset token");
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      setError("Both password fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_DOMAIN ?? ""}/api/auth/reset-password`,
        {
          token,
          newPassword,
        }
      );
      setMessage(response.data.message);
      setError("");
      navigate("/login"); // Use navigate to redirect after success
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong");
      setMessage(""); // Clear success message if error occurs
    }
  };

  return (
    <div className="bg-image d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="card shadow p-4 boxbg" style={{ width: "400px" }}>
        <div className="bg-overlay"></div>
        <div className="cont-int text-white">
          <div className="text-center mb-2">
            <Link className="navbar-brand" to="/home">
              <img width="100" src={logo} alt="Logo" />
            </Link>
          </div>
          <h2>Reset Password</h2>
          {error && <p style={{ color: "red" }}>{error}</p>}
          {message && <p style={{ color: "green" }}>{message}</p>}
          <form onSubmit={handleSubmit}>
            <div>
              <label className="form-label">New Password:</label>

              <input
                type="password"
                className="form-control"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Enter your new password"
                required
              />
            </div>
            <div className="mb-2">
              <label className="form-label">Confirm Password:</label>
              <input
                type="password"
                className="form-control"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Confirm your new password"
                required
              />
            </div>
            <button type="submit" className="btn btn-primary w-100">
              Reset Password
            </button>
          </form>
          <p className="text-center mt-3">
            Don't have an account?{" "}
            <Link to="/register" className="text-decoration-none">
              Register here
            </Link>{" "}
            |{" "}
            <Link to="/login" className="text-decoration-none">
              Login
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
